<!-- ============================================================== -->
<!-- Page wrapper  -->
<!-- ============================================================== -->
<div class="page-wrapper" style="color: #8d97ad" >
<!--[style.margin-top.px]="((layoutManager.mobileMode)?0:60) + ((!layoutManager.mobileMode && layoutManager.innerWidth<1389)?100:0)"-->

  <!-- ============================================================== -->
  <!-- Static Slider 10  -->
  <!-- ============================================================== -->
  <div class="banner-innerpage" style="background-image:url('../../assets/images/banner-bg2.jpg')">
    <div class="container">
      <!-- Row  -->
      <div class="row justify-content-center ">
        <!-- Column -->
        <div class="col-md-6 align-self-center text-center" data-aos="fade-down" data-aos-duration="1200">
          <h1 class="title">Asset-Store</h1>
          <h6 class="subtitle op-8">Sfoglia il catalogo dei nostri expert advisor, adotta il più adatto alla tua tecnica</h6> </div>
        <!-- Column -->
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="spacer">
      <div class="container" *ngIf="viewSoftware==undefined">
        <!-- Row  -->
        <div class="row justify-content-center">
          <div class="col-md-7 text-center" [style.width.px]="(layoutManager.smallMode)?300:500">
            <h2 class="title" style="color: #3e4555;">Expert Advisor di <span
              class="text-primary" style="font-size: 50px" data-period="2000">{{tmpString}}</span></h2>
            <!--<h6 class="subtitle">Sfoglia una panoramica dei nostri Expert, studia la tecnica e prova quello più adatto a tuo stile di Trading!</h6>-->
          </div>
        </div><br><br>
        <div class="row justify-content-center">
          <div style="margin: auto" [style.width.%]="(layoutManager.smallMode)?100:70">
            <mat-list>
              <ng-container *ngFor="let soft of softwares.softwares">
                <mat-list-item *ngIf="soft.approved"  class="item" (mouseenter)="selectItem(soft.software_name)" (mouseleave)="noSelectItem()">
                              <!-- matTooltip="{{'softwares-list.tooltip-1'|translate}}"-->
                  <mat-icon mat-list-icon>extension</mat-icon>
                  <h4 mat-line><b>{{soft.software_name.toUpperCase()}}</b>  -  {{basetos(soft.short_description)}}</h4>
                  <p mat-line> {{soft.versions | lastVersion}} </p>
                  <button type="button" class="btn btn-outline-primary btn-arrow" style="width: 150px" *ngIf="selectedSoftware==soft.software_name"
                      (click)="viewItem(soft.software_name)">
                    <span>Apri <i class="ti-arrow-right"></i></span>
                  </button>
                </mat-list-item>
                <div style="text-align: center; width: 100%">
                  <mat-divider style="width: 100%"></mat-divider>
                </div>
              </ng-container>
            </mat-list>
          </div>
        </div>
      </div>

      <div class="container" *ngIf="viewSoftware!= undefined">
        <button mat-icon-button style="color: #3e4555;margin-bottom: 50px" routerLink="/store">
          <mat-icon style="font-size: 50px">arrow_back</mat-icon>
        </button>
        <mat-card style="width: 100%;">
          <mat-card-header class="row">
            <table>
              <tr>
                <td>
                  <mat-icon style="font-size: 35px;margin-right: 25px;text-align: center">
                    extension</mat-icon>
                </td>
                <td>
                  <br>
                  <mat-card-title>{{software.software_name.toUpperCase()}}</mat-card-title>
                  <mat-card-subtitle>
                    <app-floating-div speed="2">
                      {{'software-pres-page.description-1'|translate}}
                      {{software.software_name}}
                      {{'software-pres-page.description-2'|translate}}
                    </app-floating-div>
                  </mat-card-subtitle>
                </td>
              </tr>
            </table>
          </mat-card-header>
          <mat-divider [inset]="true" style="margin: auto;width: 98%"></mat-divider>
          <mat-card-content style="margin-top: 20px">
            <table *ngIf="!layoutManager.smallMode">
              <tr>
                <td style="width: 100%">
                  <div style="width: 100%;font-size: 15px;" >
                    <app-floating-div speed="2" [loadDelay]="2" loadPercentage="100">
                      <p style="font-size: 20px">{{basetos(software.short_description)}}</p>
                      <p [style.width.%]="(layoutManager.smallMode)?100:80" [innerHTML]="basetos(software.description)"></p>
                    </app-floating-div>
                  </div>
                </td>
                <td>
                  <div>
                    <app-floating-div speed="2" [loadDelay]="4">
                      <mat-card style="padding: 20px">
                        <p>{{'software-pres-page.subscription-details.description-1'|translate}}</p>
                        <h1>{{software.price}}&euro;/{{software.billingPeriod|billingPeriod}}</h1>
                        <p><b>- {{'software-pres-page.subscription-details.description-2'|translate}}</b></p>
                        <p>- {{'software-pres-page.subscription-details.description-3'|translate}}</p>
                      </mat-card>
                    </app-floating-div>
                  </div>
                </td>
              </tr>
            </table>
            <div *ngIf="layoutManager.smallMode">
              <div style="width: 100%;font-size: 15px;" >
                <app-floating-div speed="2" [loadDelay]="2" loadPercentage="100">
                  <p style="font-size: 20px">{{basetos(software.short_description)}}</p>
                  <p [style.width.%]="(layoutManager.smallMode)?100:80" [innerHTML]="basetos(software.description)"></p>
                </app-floating-div>
              </div>
              <div>
                <app-floating-div speed="2" [loadDelay]="4">
                  <mat-card style="padding: 20px">
                    <p>{{'software-pres-page.subscription-details.description-1'|translate}}</p>
                    <h1>{{software.price}}&euro;/{{software.billingPeriod|billingPeriod}}</h1>
                    <p><b>- {{'software-pres-page.subscription-details.description-2'|translate}}</b></p>
                    <p>- {{'software-pres-page.subscription-details.description-3'|translate}}</p>
                  </mat-card>
                </app-floating-div>
              </div>
            </div>
            <app-floating-div speed="1" [loadDelay]="3" loadPercentage="100">
              <br>
              <mat-divider [inset]="true" style="margin: auto;width: 98%"></mat-divider>
              <br>
              <h2>
                Registra un account e attiva
                {{software.software_name.toUpperCase()}}
                nella tua area personale!
              </h2>
            </app-floating-div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>


</div>

<script type="application/javascript">
  var TxtType = function(el, toRotate, period) {
    this.toRotate = toRotate;
    this.el = el;
    this.loopNum = 0;
    this.period = parseInt(period, 10) || 2000;
    this.txt = '';
    this.tick();
    this.isDeleting = false;
  };

  TxtType.prototype.tick = function() {
    var i = this.loopNum % this.toRotate.length;
    var fullTxt = this.toRotate[i];

    if (this.isDeleting) {
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';

    var that = this;
    var delta = 200 - Math.random() * 100;

    if (this.isDeleting) { delta /= 2; }

    if (!this.isDeleting && this.txt === fullTxt) {
      delta = this.period;
      this.isDeleting = true;
    } else if (this.isDeleting && this.txt === '') {
      this.isDeleting = false;
      this.loopNum++;
      delta = 500;
    }

    setTimeout(function() {
      that.tick();
    }, delta);
  };

  window.onload = function() {
    var elements = document.getElementsByClassName('typewrite');
    console.log(elements)
    console.log('test')
    for (var i=0; i<elements.length; i++) {
      var toRotate = elements[i].getAttribute('data-type');
      var period = elements[i].getAttribute('data-period');
      if (toRotate) {
        new TxtType(elements[i], JSON.parse(toRotate), period);
      }
    }
    // INJECT CSS
    var css = document.createElement("style");
    css.type = "text/css";
    css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid transparent}";
    document.body.appendChild(css);
  };
</script>
